import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle, ExternalLink, Hand } from 'lucide-react';

const STATUS = {
  ok: { Icon: CheckCircle2, cls: 'text-green-600', text: 'Gepusht' },
  manual: { Icon: Hand, cls: 'text-amber-600', text: 'Eén keer handmatig' },
  warning: { Icon: AlertTriangle, cls: 'text-amber-600', text: 'Controleer' },
  error: { Icon: XCircle, cls: 'text-red-600', text: 'Mislukt' },
};

export const EngineCard = ({ engine }) => {
  const s = { ...(STATUS[engine.status] || STATUS.warning) };
  if (engine.id === 'ai' && engine.status === 'ok') s.text = 'Leesbaar & open';
  return (
    <div className="bg-white rounded-xl border p-5 flex flex-col gap-3" data-testid={`engine-card-${engine.id}`}>
      <div className="flex items-start justify-between gap-3">
        <h3 className="font-semibold text-[#3a190b]">{engine.label}</h3>
        <span className={`flex items-center gap-1 text-xs font-medium ${s.cls}`} data-testid={`engine-status-${engine.id}`}>
          <s.Icon className="h-4 w-4" /> {s.text}
        </span>
      </div>
      {engine.count > 0 && <p className="text-2xl font-bold text-gray-900">{engine.count} <span className="text-sm font-normal text-gray-500">URL's</span></p>}
      <p className="text-sm text-gray-600">{engine.detail}</p>
      {engine.sitemaps && (
        <ul className="text-xs text-gray-700 bg-gray-50 rounded-lg p-3 space-y-1">
          {engine.sitemaps.map((u) => <li key={u} className="font-mono break-all">{u}</li>)}
        </ul>
      )}
      {engine.action_url && (
        <a href={engine.action_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm font-medium text-[#3a190b] hover:underline" data-testid={`engine-action-${engine.id}`}>
          Open Google Search Console <ExternalLink className="h-3.5 w-3.5" />
        </a>
      )}
    </div>
  );
};
